export const DEFAULT_RETURN_URL = '/root/worklist';
export const PATIENT_NOTE_MODAL_TITLE = 'Patient Note';


// WEBPACK FOOTER //
// ./src/scripts/constants/patient-constants.js